module.exports = __webpack_public_path__ + "img/dark-back.9eab615f.svg";